import { VideoInfo } from '~/models/short-video'

export function getVideoInfoAndCoverUrl(
  file: File,
  isIos = false,
  seekTo = 0.0
): Promise<VideoInfo> {
  return new Promise((resolve, reject) => {
    // load the file to a video player
    if (!file) {
      reject(new Error('File is undefined'))
    }
    const videoPlayer = document.createElement('video')
    videoPlayer.setAttribute('src', URL.createObjectURL(file))
    if (isIos) {
      videoPlayer.currentTime = seekTo
    }
    videoPlayer.load()
    videoPlayer.addEventListener('error', ex => {
      reject(new Error(`error when loading video file ${ex}`))
    })
    // load metadata of the video to get video duration and dimensions
    videoPlayer.addEventListener('loadedmetadata', () => {
      // seek to user defined timestamp (in seconds) if possible
      // metaInfo
      if (videoPlayer.duration < seekTo) {
        reject(new Error('video is too short.'))
        return
      }
      // delay seeking or else 'seeked' event won't fire on Safari
      setTimeout(() => {
        videoPlayer.currentTime = seekTo
      }, 200)
      // extract video thumbnail once seeking is complete
      videoPlayer.addEventListener('seeked', () => {
        // define a canvas to have the same dimension as the video
        const canvas = document.createElement('canvas')
        canvas.width = videoPlayer.videoWidth
        canvas.height = videoPlayer.videoHeight
        // draw the video frame to canvas
        const ctx = canvas.getContext('2d')
        if (ctx) {
          ctx.drawImage(videoPlayer, 0, 0, canvas.width, canvas.height)
          // return the canvas image as a blob

          ctx.canvas.toBlob(
            blob => {
              resolve({
                duration: videoPlayer.duration,
                width: videoPlayer.videoHeight,
                height: videoPlayer.videoWidth,
                coverUrl: blob ? URL.createObjectURL(blob as Blob) : ''
              })
            },
            'image/jpeg',
            0.75 /* quality */
          )
        }
      })
    })
  })
}
